module.exports = __webpack_public_path__ + "img/Frame 5132.bb1f3c6d.jpg";